import { css } from 'lit';

export const levelHeaderStyles = css`
  :host {
    display: block;
    position: -webkit-sticky;
    position: sticky;
    z-index: 3;
  }

  :host(#small-header),
  :host(#large-header) {
    position: absolute;
    width: 100%;
    visibility: hidden;
  }

  .header-wrapper {
    position: -webkit-sticky;
    position: sticky;
    top: calc(-1px + 0px);
    z-index: 3;
  }

  .special-header {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    box-sizing: border-box;
    background-color: hsl(1, 0%, 96%);
    padding: 10px 20px 14px 20px;
    color: hsl(1, 0%, 40%);
    overflow: hidden;
    transition:
      max-height,
      padding 0.3s;
  }

  :host([covered]) .special-header {
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  .special-header + .special-header {
    border-top: 1px solid var(--borderColor);
  }

  .special-header d-label {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    margin: 0;
    padding: 6px 0 0 32px;
    background-position: -4px -2px;
    background-repeat: no-repeat;
    background-size: 32px 32px;
    color: hsl(1, 0%, 40%);
  }

  .special-header .actions d-action {
    margin: -5px -8px -8px 0;
  }

  .draft-header d-label {
    background-image: url(/images/draft.svg);
  }

  .trash-header d-label {
    background-image: url(/images/trash.svg);
  }

  .emergency-header d-label {
    background-image: url(/images/emergency-color.svg);
    background-position: -3px 0;
    padding: 6px 0 3px 34px;
  }

  .header {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    padding-top: 10px;
    z-index: 3;
    transition: all var(--transition);
  }

  :host(:not([no-margin])) .header {
    margin-right: 20px;
    margin-left: 20px;
  }

  :host(.width600:not([no-margin])) .header {
    margin-right: 30px;
    margin-left: 30px;
  }

  :host([covered]) .header {
    padding-top: 2px;
  }

  .header .actions {
    display: flex;
    flex: none;
    align-self: flex-start;
    text-align: right;
    max-height: 36px;
    margin: -8px -8px -10px 0;
    transition: all var(--transition);
  }

  d-more-menu {
    margin-bottom: -11px;
    margin-right: -8px;
    margin-left: -4px;
  }

  .actions ::slotted(d-action) {
    font-size: 10px;
  }

  .header-link {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  :host([covered]) .actions {
    max-height: 0;
    overflow: hidden;
  }

  .title {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    overflow: hidden;
    margin: 0;
    padding: 14px 0 18px 0;
    background-position: 0 6px;
    background-repeat: no-repeat;
    mix-blend-mode: multiply;
    color: var(--pageHeaderColor);
    font-family: var(--mainSans), sans-serif;
    font-weight: bold;
    font-size: 22px;
    line-height: 110%;
    word-break: break-word;
    transition:
      min-height var(--transition),
      font-size var(--transition),
      line-height var(--transition),
      padding var(--transition),
      margin var(--transition),
      background-position var(--transition),
      background-size var(--transition);
  }

  .title.icon {
    padding-left: 40px;
    background-size: 40px 40px;
    background-position: -4px 5px;
  }

  .title.icon.robot {
    /*
     * The robot is rendered as a background-image (i.e. the SVG is treated as an
     * image, not inline DOM). WebKit/Safari does not run CSS animations inside an
     * SVG loaded this way, and with an internal <style> block the eye fills/opacity
     * were driven by an animation that fell back to its last keyframe (opacity: 0),
     * making the eyes disappear in production. Use plain presentation attributes so
     * the eyes always render in every browser. See issue #13465.
     */
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 100 100"><rect fill="%2315ade5" width="100" height="100" rx="20" /><circle fill="%23ffffff" cx="28.75" cy="32.5" r="12.5" /><circle fill="%23ffffff" cx="71.25" cy="32.5" r="12.5" /><circle fill="%2315ade5" cx="28.75" cy="32.5" r="7.5" /><circle fill="%2315ade5" cx="71.25" cy="32.5" r="7.5" /><path fill="%23000000" opacity="0.4" d="M27.65 62.5a22.49 22.49 0 0 0 44.7 0Z" /></svg>');
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-position: 0 9px;
  }

  :host([covered]) .title {
    top: 6px;
    margin-top: 2px;
    padding: 8px 0 14px 0;
    font-size: 15px;
  }

  :host([covered]) .title {
    color: hsl(1, 0%, 50%);
    cursor: pointer;
  }

  @media (hover: hover) {
    :host([covered]) .title:hover {
      color: black;
    }
  }

  :host([covered]) .title.icon {
    background-size: 30px 30px;
    background-position: -2px 1px;
    padding-left: var(--listPaddingLeft);
  }

  :host([covered]) .title.icon.robot {
    background-size: 24px 24px;
    background-position: 0 3px;
  }

  .name {
    margin-right: 0.2em;
    -webkit-user-select: text;
    -ms-user-select: text;
    -moz-user-select: text;
    user-select: text;
  }

  :host(.width600) .actions ::slotted(d-action) {
    font-size: 11px;
  }

  :host(:not([covered]).width600) .header {
    padding-top: 16px;
    padding-bottom: 6px;
  }

  :host(:not([covered]).width600) .title {
    font-size: 32px;
  }

  :host(:not([covered]).width600) .title.icon {
    padding-left: 60px;
    background-size: 60px 60px;
    background-position: -6px 0;
  }

  :host(:not([covered]).width600) .title.icon.robot {
    background-position: 0 6px;
    background-size: 48px auto;
  }

  @media only screen and (max-height: 800px) {
    :host(:not([covered]).width600) .title {
      font-size: 22px;
    }
    :host(:not([covered]).width600) .title.icon {
      padding-left: 40px;
      background-size: 40px 40px;
      background-position: -4px 5px;
    }
    :host(:not([covered]).width600) .title.icon.robot {
      background-size: 32px 32px;
      background-position: 0 9px;
    }
  }
`;
